import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CurrencyComponent } from './currency/currency.component';
import { CountryComponent } from './country/country.component';
import { NetworkComponent } from './network/network.component';
import { BankComponent } from './bank/bank.component';
import { DirectionComponent } from './direction/direction.component';
import { DepartementComponent } from './departement/departement.component';
import { CityComponent } from './city/city.component';
import { PermissionComponent } from './permission/permission.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { UserComponent } from './user/user.component';
import { WorkflowComponent } from './workflow/workflow.component';
import { RequestStatusComponent } from './request-status/request-status.component';
import { FormulaireComponent } from './formulaire/formulaire.component';
import { ServiceExecutionComponent } from './service-execution/service-execution.component';
import { TaskComponent } from './task/task.component';
import { TypeCreditComponent } from './type-credit/type-credit.component';
import { LegalFormComponent } from './legal-form/legal-form.component';
import { ActivityAreaComponent } from './activity-area/activity-area.component';
import { AssuranceComponent } from './assurance/assurance.component';
import { AnneeComponent } from './annee/annee.component';
import { FerierComponent } from './ferier/ferier.component';
import { TypeCongesComponent } from './type-conges/type-conges.component';
import { StatutDossierComponent } from './statut-dossier/statut-dossier.component';
import { MarcheComponent } from './marche/marche.component';
import { FournisseurAgreeComponent } from './fournisseur-agree/fournisseur-agree.component';
import { AddCityComponent } from './city/add-city/add-city.component';
import { EditCityComponent } from './city/edit-city/edit-city.component';
import { AddBankComponent } from './bank/add-bank/add-bank.component';
import { EditBankComponent } from './bank/edit-bank/edit-bank.component';
import { EditCountryComponent } from './country/edit-country/edit-country.component';
import { AddTypeCreditComponent } from './type-credit/add-type-credit/add-type-credit.component';
import { EditTypeCreditComponent } from './type-credit/edit-type-credit/edit-type-credit.component';
import { ProduitComponent } from './produit/produit.component';
import { AddProduitComponent } from './produit/add-produit/add-produit.component';
import { EditProduitComponent } from './produit/edit-produit/edit-produit.component';
import { GarantieProduitComponent } from './garantie-produit/garantie-produit.component';
import { LimiteProduitComponent } from './limite-produit/limite-produit.component';
import { AddLegalFormComponent } from './legal-form/add-legal-form/add-legal-form.component';
import { EditLegalFormComponent } from './legal-form/edit-legal-form/edit-legal-form.component';
import { AddActivityAreaComponent } from './activity-area/add-activity-area/add-activity-area.component';
import { EditActivityAreaComponent } from './activity-area/edit-activity-area/edit-activity-area.component';
import { AddTaskComponent } from './task/add-task/add-task.component';
import { EditTaskComponent } from './task/edit-task/edit-task.component';
import { AffectationComponent } from './affectation/affectation.component';
import { TaskDocumentComponent } from './task-document/task-document.component';
import { AddPermissionComponent } from './permission/add-permission/add-permission.component';
import { EditPermissionComponent } from './permission/edit-permission/edit-permission.component';
import { EditUserProfileComponent } from './user-profile/edit-user-profile/edit-user-profile.component';
import { PermissionByProfileComponent } from './user-profile/permission-by-profile/permission-by-profile.component';
import { RuleEngineComponent } from './rule-engine/rule-engine.component';
import { CheckListDocumentComponent } from './check-list-document/check-list-document.component';
import { SmtpConfigComponent } from './smtp-config/smtp-config.component';
import { EmployeurComponent } from './employeur/employeur.component';
import { ProfileByUserComponent } from './user/profile-by-user/profile-by-user.component';
import { AddUserComponent } from './user/add-user/add-user.component';
import { EditUserComponent } from './user/edit-user/edit-user.component';
import { NatureGarantieComponent } from './garantie/nature-garantie/nature-garantie.component';
import { TypesDocumentsGarantiesComponent } from './garantie/types-documents-garanties/types-documents-garanties.component';
import { ChampFormGarantieComponent } from './garantie/champ-form-garantie/champ-form-garantie.component';
import { MembreComiteComponent } from './membre-comite/membre-comite.component';
import { ObjectifProfilTypeCreditComponent } from './objectif-profil-type-credit/objectif-profil-type-credit.component';
import { ChampProduitCrmComponent } from './produit-crm/champ-produit-crm/champ-produit-crm.component';
import { TypeDocumentProduitCrmComponent } from './produit-crm/type-document-produit-crm/type-document-produit-crm.component';
import { NatureProduitCrmComponent } from './produit-crm/nature-produit-crm/nature-produit-crm.component';
import { ClassificationEmployeurComponent } from './classification-employeur/classification-employeur.component';
import { ParametreGeneralComponent } from './parametre-general/parametre-general.component';
import { LigneFinancementComponent } from './ligneFinancement/ligne-financement/ligne-financement.component';
import { LigneFinancementMarcheComponent } from './ligneFinancement/ligne-financement-marche/ligne-financement-marche.component';
import { LigneFinancementProduitComponent } from './ligneFinancement/ligne-financement-produit/ligne-financement-produit.component';
import { LigneFinancementSecteurComponent } from './ligneFinancement/ligne-financement-secteur/ligne-financement-secteur.component';


const routes: Routes = [
  { path: "", component: CurrencyComponent },
  {
    path: "parametrage",
    children: [
      {
        path: "currency",
        component: CurrencyComponent,
        data: { breadcrumb: "currency" }
      },
      {
        path: "country",
        component: CountryComponent,
        data: { breadcrumb: "country" }
      },
      {
        path: "country/edit-country/:countryId",
        component: EditCountryComponent
      },

      {
        path: "network",
        component: NetworkComponent,
        data: { breadcrumb: "network" }
      },

      {
        path: "city",
        component: CityComponent,
        data: { breadcrumb: "city" }
      },
      { path: "city/add-city", component: AddCityComponent },
      { path: "city/edit-city/:cityId", component: EditCityComponent },

      {
        path: "bank",
        component: BankComponent,
        data: { breadcrumb: "bank" }
      },
      { path: "bank/add-bank", component: AddBankComponent },
      { path: "bank/edit-bank/:bankId", component: EditBankComponent },

      {
        path: "direction",
        component: DirectionComponent,
        data: { breadcrumb: "direction" }
      },
      {
        path: "departement",
        component: DepartementComponent,
        data: { breadcrumb: "departement" }
      },

      //
      {
        path: "permission",
        component: PermissionComponent,
        data: { breadcrumb: "permission" }
      },
      { path: "permission/add-permission", component: AddPermissionComponent },
      {
        path: "permission/edit-permission/:permissionId",
        component: EditPermissionComponent
      },

      {
        path: "user-profile",
        component: UserProfileComponent,
        data: { breadcrumb: "user-profile" }
      },
      {
        path: "user-profile/edit-user-profile/:profileId",
        component: EditUserProfileComponent
      },
      {
        path: "user-profile/permission-by-profile/:profileId",
        component: PermissionByProfileComponent
      },

      {
        path: "user",
        component: UserComponent,
        data: { breadcrumb: "user" }
      },
      { path: "user/add-user", component: AddUserComponent },
      { path: "user/edit-user/:userId", component: EditUserComponent },
      {
        path: "user/profile-by-user/:userId",
        component: ProfileByUserComponent
      },
      //

      {
        path: "workflow",
        component: WorkflowComponent,
        data: { breadcrumb: "workflow" }
      },
      {
        path: "request-status",
        component: RequestStatusComponent,
        data: { breadcrumb: "request-status" }
      },
      {
        path: "formulaire",
        component: FormulaireComponent,
        data: { breadcrumb: "formulaire" }
      },
      {
        path: "service-execution",
        component: ServiceExecutionComponent,
        data: { breadcrumb: "service-execution" }
      },
      {
        path: "task",
        component: TaskComponent,
        data: { breadcrumb: "task" }
      },
      { path: "task/add-task", component: AddTaskComponent },
      { path: "task/edit-task/:taskId", component: EditTaskComponent },

      { path: "affectation/:taskId", component: AffectationComponent },

      { path: "task-document/:taskId", component: TaskDocumentComponent },
      //

      // Ligne financement

      {
        path: "ligne-financement",
        component: LigneFinancementComponent,
        data: { breadcrumb: "ligne financement" }
      },
      {
        path: "ligne-financement-marche",
        component: LigneFinancementMarcheComponent,
        data: { breadcrumb: "ligne financement marché" }
      },
      {
        path: "ligne-financement-secteur",
        component: LigneFinancementSecteurComponent,
        data: { breadcrumb: "ligne financement secteur" }
      },
      {
        path: "ligne-financement-produit",
        component: LigneFinancementProduitComponent,
        data: { breadcrumb: "ligne financement produit" }
      },

      //

      {
        path: "type-credit",
        component: TypeCreditComponent,
        data: { breadcrumb: "type-credit" }
      },
      {
        path: "type-credit/add-type-credit",
        component: AddTypeCreditComponent
      },
      {
        path: "type-credit/edit-type-credit/:typeCreditId",
        component: EditTypeCreditComponent
      },

      {
        path: "produit/:typeCreditId",
        component: ProduitComponent,
        data: { breadcrumb: "Produit par type de crédit" }
      },
      {
        path: "produit/add-produit/:typeCreditId",
        component: AddProduitComponent
      },
      {
        path: "produit/edit-produit/:produitId",
        component: EditProduitComponent
      },

      {
        path: "garantie-produit/:produitId",
        component: GarantieProduitComponent
      },

      { path: "limite-produit/:produitId", component: LimiteProduitComponent },

      {
        path: "legal-form",
        component: LegalFormComponent,
        data: { breadcrumb: "legal-form" }
      },
      { path: "legal-form/add-legal-form", component: AddLegalFormComponent },
      {
        path: "legal-form/edit-legal-form/:legalFormId",
        component: EditLegalFormComponent
      },

      {
        path: "activity-area",
        component: ActivityAreaComponent,
        data: { breadcrumb: "activity-area" }
      },
      {
        path: "activity-area/add-activity-area",
        component: AddActivityAreaComponent
      },
      {
        path: "activity-area/edit-activity-area/:activityAreaId",
        component: EditActivityAreaComponent
      },

      {
        path: "assurance",
        component: AssuranceComponent,
        data: { breadcrumb: "assurance" }
      },
      {
        path: "annee",
        component: AnneeComponent,
        data: { breadcrumb: "annee" }
      },
      {
        path: "ferie",
        component: FerierComponent,
        data: { breadcrumb: "ferie" }
      },

      {
        path: "parametre-general",
        component: ParametreGeneralComponent,
        data: { breadcrumb: "Parametre general" }
      },
      {
        path: "type-conges",
        component: TypeCongesComponent,
        data: { breadcrumb: "type-conges" }
      },
      {
        path: "statut-dossier",
        component: StatutDossierComponent,
        data: { breadcrumb: "statut-dossier" }
      },

      {
        path: "marche",
        component: MarcheComponent,
        data: { breadcrumb: "marche" }
      },
      {
        path: "fournisseur-agree",
        component: FournisseurAgreeComponent,
        data: { breadcrumb: "fournisseur" }
      },
      {
        path: "garantie/nature-garanties",
        component: NatureGarantieComponent,
        data: { breadcrumb: "nature-garanties" }
      },
      {
        path: "garantie/champ-form-garanties",
        component: ChampFormGarantieComponent,
        data: { breadcrumb: "Champs formulaire garantie" }
      },
      {
        path: "garantie/types-documents-garanties",
        component: TypesDocumentsGarantiesComponent,
        data: { breadcrumb: "Types documents garanties" }
      },

      {
        path: "produit-crm/nature-produit-crm",
        component: NatureProduitCrmComponent,
        data: { breadcrumb: "nature-garanties" }
      },

      {
        path: "produit-crm/champ-form-produit-crm",
        component: ChampProduitCrmComponent,
        data: { breadcrumb: "Champs formulaire produit crm" }
      },

      {
        path: "rule-engine",
        component: RuleEngineComponent,
        data: { breadcrumb: "rule" }
      },

      {
        path: "check-list-document",
        component: CheckListDocumentComponent,
        data: { breadcrumb: "check-list" }
      },

      {
        path: "smtp-config",
        component: SmtpConfigComponent,
        data: { breadcrumb: "check-list" }
      },

      {
        path: "employeur",
        component: EmployeurComponent,
        data: { breadcrumb: "employeur" }
      },

      {
        path: "classification-employeur",
        component: ClassificationEmployeurComponent,
        data: { breadcrumb: "Classification Employeur" }
      },

      {
        path: "membre-comite",
        component: MembreComiteComponent,
        data: { breadcrumb: "Membres du CSC" }
      },

      {
        path: "objectif-type-credit-by-profil",
        component: ObjectifProfilTypeCreditComponent,
        data: { breadcrumb: "Objectif" }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ParametrageRoutingModule { }